import n from "./index296.mjs";
function i(t, r, o, e) {
  return n(t, r, o) ? e : t.getTime() > r.getTime() ? "'下个'" + e : "'上个'" + e;
}
var u = {
  lastWeek: i,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: i,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
};
function a(t, r, o, e) {
  var f = u[t];
  return typeof f == "function" ? f(r, o, e, "eeee p") : f;
}
export {
  a as default
};
//# sourceMappingURL=index200.mjs.map
